module.exports = __webpack_public_path__ + "img/clients.30cff2d5.svg";